module.exports = __webpack_public_path__ + "static/media/Team-invoice-pic-2.299241f7.png";